import PageShell from "@/components/opsiq/PageShell";
import OpsIndustriesCards from "@/components/opsiq/OpsIndustriesCards";

export default function IndustriesPage() {
  return (
    <PageShell
      testid="industries-page"
      eyebrow="Industries · 13 sectors"
      title={<>Every industry. <span className="italic">Same disciplined method.</span></>}
      subtitle="From banks in Accra to farms in Tamale — OpsIQ tailors the same 7D methodology to the specific rhythms of your sector."
    >
      <OpsIndustriesCards />
    </PageShell>
  );
}
